module.exports = __webpack_public_path__ + "static/MsJisola-79adf31b6e02f5af5b2e57f8ee37c376.jpg";